app.config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider', '$httpProvider',
        function ($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider) {

            $locationProvider.html5Mode(true);

            const timestamp = Date.now();

            function getTimeVersionedURL(url) {

                if (!url || (url.indexOf('views/') !== 0 && url.indexOf('/views/') !== 0) || (url.indexOf('.html') < 0 && url.indexOf('.htm') < 0) || url.indexOf('timestamp=') > 0) {
                    return url;
                }
                const param = 'timestamp=' + timestamp;
                if (url.indexOf('?') > 0) {
                    return url + '&' + param;
                }
                return url + '?' + param;
            }

            $httpProvider.interceptors.push(function () {
                return {
                    'request': function (config) {
                        config.url = getTimeVersionedURL(config.url);
                        return config;
                    }
                };
            });

            $urlRouterProvider.rule(function ($injector, $location) {

                const path = $location.path();
                const hasTrailingSlash = path[path.length - 1] === '/';

                if (hasTrailingSlash) {

                    //if last character is a slash, return the same url without the slash
                    return path.substr(0, path.length - 1);
                }

            });

            // For any unmatched url, send to /route1
            $urlRouterProvider.otherwise("/dashboard");
            $urlRouterProvider.when('/account', '/account/summary');
            $urlRouterProvider.when('/staff', '/staff/customer');
            $urlRouterProvider.when('/order-history', '/order-history/submitted');
            $urlRouterProvider.when('/quotations', '/quotations/saved');

            $stateProvider
                .state("login", {
                    url: "/login",
                    views: {
                        main: {
                            templateUrl: "views/login/login.htm"
                        }
                    }
                })
                .state("register", {
                    url: "/register",
                    views: {
                        main: {
                            templateUrl: "views/login/login-registration.htm"
                        }
                    }
                })
                .state("myba", {
                    url: "",
                    views: {
                        main: {
                            templateUrl: "views/index.htm"
                        }
                    }, sticky: true, dsr: true
                })
                .state("myba.dashboard", {
                    url: "/dashboard",
                    templateUrl: "views/dashboard.htm"
                })


                .state("myba.browse", {
                    url: "/browse",
                    templateUrl: "views/browse/browse.htm",
                    data: {is_browse: true}
                })

                .state("myba.browse.value-0", {
                    url: "/:value_0"
                })

                .state("myba.browse.value-0.value-1", {
                    url: "/:value_1"
                })

                .state("myba.browse.value-0.value-1.value-2", {
                    url: "/:value_2"
                })

                .state("myba.browse.value-0.value-1.value-2.value-3", {
                    url: "/:value_3"
                })

                .state("myba.browse.value-0.value-1.value-2.value-3.value-4", {
                    url: "/:value_4"
                })

                .state("myba.browse.value-0.value-1.value-2.value-3.value-4.value-5", {
                    url: "/:value_5"
                })

                .state("myba.browse.value-0.value-1.value-2.value-3.value-4.value-5.value-6", {
                    url: "/:value_6"
                })

                .state("myba.browse.value-0.value-1.value-2.value-3.value-4.value-5.value-6.value-7", {
                    url: "/:value_7"
                })

                .state("myba.browse.value-0.value-1.value-2.value-3.value-4.value-5.value-6.value-7.value-8", {
                    url: "/:value_8"
                })

                .state("myba.browse.value-0.value-1.value-2.value-3.value-4.value-5.value-6.value-7.value-8.value-9", {
                    url: "/:value_9"
                })

                .state("myba.browse.value-0.value-1.value-2.value-3.value-4.value-5.value-6.value-7.value-8.value-9.value-10", {
                    url: "/:value_10"
                })

                .state("myba.browse.value-0.value-1.value-2.value-3.value-4.value-5.value-6.value-7.value-8.value-9.value-10.value-11", {
                    url: "/:value_11"
                })

                .state("myba.browse.value-0.value-1.value-2.value-3.value-4.value-5.value-6.value-7.value-8.value-9.value-10.value-11.value-12", {
                    url: "/:value_12"
                })

                .state("myba.browse.value-0.value-1.value-2.value-3.value-4.value-5.value-6.value-7.value-8.value-9.value-10.value-11.value-12.value-13", {
                    url: "/:value_13"
                })

                .state("myba.browse.value-0.value-1.value-2.value-3.value-4.value-5.value-6.value-7.value-8.value-9.value-10.value-11.value-12.value-13.value-14", {
                    url: "/:value_14"
                })

                .state("myba.browse.value-0.value-1.value-2.value-3.value-4.value-5.value-6.value-7.value-8.value-9.value-10.value-11.value-12.value-13.value-14.value-15", {
                    url: "/:value_15"
                })


                .state("myba.account", {
                    url: "/account",
                    templateUrl: "views/account/account.htm"
                })
                .state("myba.account.summary", {
                    url: "/summary",
                    templateUrl: "views/account/account-summary.htm"
                })
                .state("myba.account.detail", {
                    url: "/details",
                    templateUrl: "views/account/account-detail.htm"
                })
                .state("myba.account.discount", {
                    url: "/discounts",
                    templateUrl: "views/account/account-discount.htm"
                })
                .state("myba.account.statement", {
                    url: "/statement",
                    templateUrl: "views/account/account-statement.htm"
                })
                .state("myba.account.admin-tools", {
                    url: "/admin-tools",
                    templateUrl: "views/account/account-admin-tools.htm"
                })
                .state("myba.account-payment", {
                    url: "/account/payments",
                    templateUrl: "views/account/account-payment.htm"
                })
                .state("myba.account-payment-processing", {
                    url: "/account/payments/processing/:payment_id",
                    templateUrl: "views/account/account-payment-processing.htm"
                })
                .state("myba.account-payment-acknowledgement", {
                    url: "/account/payments/acknowledgement/:payment_id",
                    templateUrl: "views/account/account-payment-acknowledgement.htm"
                })
                .state("myba.account-address-edit", {
                    url: "/account/address/edit/:address_id",
                    templateUrl: "views/account/account-address-edit.htm"
                })
                .state("myba.account-address-add-new", {
                    url: "/account/address/add-new",
                    templateUrl: "views/account/account-address-add-new.htm"
                })


                .state("myba.staff-customer", {
                    url: "/staff/customer",
                    templateUrl: "views/staff/staff-customer.htm"
                })
                .state("myba.staff-customer-entry", {
                    url: "/staff/customer/:customer_code",
                    templateUrl: "views/staff/staff-customer-entry.htm"
                })
                .state("myba.staff-customer-order-entry", {
                    url: "/staff/customer/:customer_code/:order_id",
                    templateUrl: "views/order/history/order-history-submitted-entry.htm"
                })
                .state("myba.staff-discount", {
                    url: "/staff/discount",
                    templateUrl: "views/staff/staff-discount.htm"
                })


                .state("myba.order-checkout", {
                    url: "/submitorder",
                    templateUrl: "views/order/checkout/order-checkout.htm"
                })
                .state("myba.order-checkout.review", {
                    url: "/submitorder/review",
                    data: {checkout_state_id: 'review'}
                })
                .state("myba.order-checkout.delivery", {
                    url: "/submitorder/delivery",
                    data: {checkout_state_id: 'delivery'}
                })
                .state("myba.order-checkout-processing", {
                    url: "/submitorder/processing",
                    templateUrl: "views/order/checkout/order-checkout-processing.htm"
                })
                .state("myba.order-checkout-acknowledgement", {
                    url: "/submitorder/acknowledgement",
                    templateUrl: "views/order/checkout/order-checkout-acknowledgement.htm"
                })
                .state("myba.order-checkout.entry", {
                    url: "/:order_id"
                })
                .state("myba.order-checkout-processing.entry", {
                    url: "/:order_id",
                })
                .state("myba.order-checkout-acknowledgement.entry", {
                    url: "/:order_id",
                })
                .state("myba.order-transfer-entry", {
                    url: "/order-transfer/:order_id",
                    templateUrl: "views/order/transfer/order-transfer.htm"
                })

                .state("myba.order-history-submitted", {
                    url: "/order-history/submitted",
                    templateUrl: "views/order/history/order-history-submitted.htm"
                })
                .state("myba.order-history-submitted-entry", {
                    url: "/order-history/submitted/order",
                    templateUrl: "views/order/history/order-history-submitted-entry.htm"
                })
                .state("myba.order-history-submitted-entry.entry", {
                    url: "/:order_id"
                })
                .state("myba.order-history-web", {
                    url: "/order-history/saved",
                    templateUrl: "views/order/history/order-history-web.htm"
                })
                .state("myba.order-history-web-entry", {
                    url: "/order-history/saved/order",
                    templateUrl: "views/order/history/order-history-web-entry.htm"
                })
                .state("myba.order-history-web-entry.entry", {
                    url: "/:order_id"
                })
                .state("myba.order-history-archive", {
                    url: "/order-history/archive",
                    templateUrl: "views/order/history/order-history-archive.htm"
                })


                .state("myba.order-quote-saved", {
                    url: "/quotations/saved",
                    templateUrl: "views/order/quote/order-quote-saved.htm"
                })
                .state("myba.order-quote-saved-entry", {
                    url: "/quotations/saved/quote",
                    templateUrl: "views/order/quote/order-quote-saved-entry.htm"
                })
                .state("myba.order-quote-saved-entry.entry", {
                    url: "/:order_id"
                })
                .state("myba.order-quote-archive", {
                    url: "/quotations/archive",
                    templateUrl: "views/order/quote/order-quote-archive.htm"
                })
                .state("myba.order-quote-default", {
                    url: "/quotations/defaults",
                    templateUrl: "views/order/quote/order-quote-default.htm"
                })
                .state("myba.order-quote-end", {
                    url: "/quotations/end-current",
                    templateUrl: "views/order/quote/order-quote-end.htm"
                })
                .state("myba.order-quote-extra", {
                    url: "/quotations/extras",
                    templateUrl: "views/order/quote/order-quote-extra.htm"
                })
                .state("myba.order-quote-manage", {
                    url: "/quotations/manage-current",
                    templateUrl: "views/order/quote/order-quote-manage.htm"
                })

                .state("myba.order-replacement", {
                    url: "/replacement",
                    templateUrl: "views/order/replacement/order-replacement.htm"
                })
                .state("myba.order-replacement-entry", {
                    url: "/replacement/:replacement_id",
                    templateUrl: "views/order/replacement/order-replacement-entry.htm"
                })
                .state("myba.order-replacement-entry-acknowledgement", {
                    url: "/replacement/acknowledgement/:replacement_id",
                    templateUrl: "views/order/replacement/order-replacement-entry.htm",
                    data: {is_acknowledgement: true}
                })
                .state("myba.order-replacement-entry-add", {
                    url: "/replacement/add/:order_id",
                    templateUrl: "views/order/replacement/order-replacement-entry-add.htm"
                })


                .state("myba.support-bug-report", {
                    url: "/report-a-bug",
                    templateUrl: "views/support/support-bug-report.htm"
                })
                .state("myba.support-ordering-process", {
                    url: "/ordering-process",
                    templateUrl: "views/support/support-ordering-process.htm"
                })
                .state("myba.support-delivery-off-shore", {
                    url: "/delivery-off-shore",
                    templateUrl: "views/support/support-delivery-off-shore.htm",
                    data: {data_api_id: 'document'}
                })
                .state("myba.support-price-list", {
                    url: "/price-list",
                    templateUrl: "views/support/support-price-list.htm",
                    data: {data_api_id: 'document'}
                })
                .state("myba.support-conditions-of-sale", {
                    url: "/conditions-of-sale",
                    templateUrl: "views/support/support-conditions-of-sale.htm",
                    data: {data_api_id: 'document'}
                })

                .state("myba.announcement", {
                    url: "/communication-updates",
                    templateUrl: "views/support/announcement/support-announcement.htm",
                    data: {data_api_id: 'announcement'}
                })
                .state("myba.announcement.category", {
                    url: "/:category_slug",
                    templateUrl: "views/support/announcement/support-announcement-category.htm",
                })
                .state("myba.announcement.category.post", {
                    url: "/:post_slug",
                    templateUrl: "views/support/announcement/support-announcement-category-post.htm",
                })

                .state("myba.article", {
                    url: "/articles",
                    templateUrl: "views/support/article/support-article.htm",
                    data: {data_api_id: 'article'}
                })
                .state("myba.article.category", {
                    url: "/:category_slug",
                    templateUrl: "views/support/article/support-article-category.htm"
                })
                .state("myba.article.category.post", {
                    url: "/:post_slug",
                    templateUrl: "views/support/article/support-article-category-post.htm"
                })

                .state("myba.document", {
                    url: "/documents",
                    templateUrl: "views/support/document/support-document.htm",
                    data: {data_api_id: 'document'}
                })
                .state("myba.document.category", {
                    url: "/:category_slug",
                    templateUrl: "views/support/document/support-document-category.htm"
                })

                .state("myba.marketing-asset", {
                    url: "/marketing-assets",
                    templateUrl: "views/support/marketing-asset/support-marketing-asset.htm",
                    data: {data_api_id: 'marketing_asset'}
                })
                .state("myba.marketing-asset.category", {
                    url: "/:category_slug",
                    templateUrl: "views/support/marketing-asset/support-marketing-asset-category.htm"
                })
                .state("myba.marketing-asset.category.child-category", {
                    url: "/:child_category_slug",
                })

                .state("myba.person", {
                    url: "/contact",
                    templateUrl: "views/support/person/support-person.htm",
                    data: {data_api_id: 'person'}
                })
                .state("myba.person.category", {
                    url: "/:category_slug",
                    templateUrl: "views/support/person/support-person-category.htm"
                })

                .state("myba.video", {
                    url: "/videos",
                    templateUrl: "views/support/video/support-video.htm",
                    data: {data_api_id: 'video'}
                })
                .state("myba.video.category", {
                    url: "/:category_slug",
                    templateUrl: "views/support/video/support-video-category.htm"
                })
                .state("myba.video.category.post", {
                    url: "/:post_slug",
                    templateUrl: "views/support/video/support-video-category-post.htm"
                })

        }]);